<template>
  <cash></cash>
</template>
<script>
import Cash from '@this/connect/List/Cash';
export default {
  components: {
    Cash,
  },
};
</script>
<style lang="scss" scoped>
.coupon {
  margin-right: 50px;
}
</style>
